import React, { useState, useRef, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import { useAuth } from '../../contexts/AuthContext';

// ── Charte Arcus — Sidebar "Ardoise" ─────────────────────────
const ORANGE     = '#F18A00';
const ORANGE_SOFT= '#F4A94E';
const SIDEBAR    = '#2B3440';   // ardoise
const WHITE      = '#FFFFFF';
const MUTED      = '#C3D0DD';   // texte items inactifs
const FAINT      = '#7E8EA0';   // libellés de section
const DIVIDER    = '#3A4654';
const HOVER_BG   = '#323B47';

// ── Icônes SVG inline (style Tabler, trait 1.75) ──────────────
const Icon = ({ d, size = 19, color = 'currentColor', children }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
    stroke={color} strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"
    style={{ flexShrink: 0 }}>
    {children || <path d={d} />}
  </svg>
);

const Icons = {
  briefcase: (c) => (<Icon color={c}><path d="M3 7m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v9a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"/><path d="M8 7v-2a2 2 0 0 1 2 -2h4a2 2 0 0 1 2 2v2"/><path d="M12 12l0 .01"/><path d="M3 13a20 20 0 0 0 18 0"/></Icon>),
  users: (c) => (<Icon color={c}><path d="M9 7m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0"/><path d="M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/><path d="M21 21v-2a4 4 0 0 0 -3 -3.85"/></Icon>),
  alert: (c) => (<Icon color={c}><path d="M12 9v4"/><path d="M10.363 3.591l-8.106 13.534a1.914 1.914 0 0 0 1.636 2.871h16.214a1.914 1.914 0 0 0 1.636 -2.87l-8.106 -13.536a1.914 1.914 0 0 0 -3.274 0z"/><path d="M12 16h.01"/></Icon>),
  truck: (c) => (<Icon color={c}><path d="M3 17v-11a1 1 0 0 1 1 -1h9v12M14 17v-7h5l3 4v3h-2M6 17h8M9 17a2 2 0 1 0 4 0a2 2 0 0 0 -4 0M17 17a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"/></Icon>),
  hourglass: (c) => (<Icon color={c}><path d="M6.5 7h11M6.5 17h11M6 20v-2a4 4 0 0 1 1.5 -3.1l1.5 -1l-1.5 -1a4 4 0 0 1 -1.5 -3.1v-2h12v2a4 4 0 0 1 -1.5 3.1l-1.5 1l1.5 1a4 4 0 0 1 1.5 3.1v2z"/></Icon>),
  banknote: (c) => (<Icon color={c}><path d="M3 7m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2zM12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0M6 10v.01M18 14v.01"/></Icon>),
  check_circle: (c) => (<Icon color={c}><path d="M12 21a9 9 0 1 1 0 -18a9 9 0 0 1 0 18zM9 12l2 2l4 -4"/></Icon>),
  shield: (c) => (<Icon color={c}><path d="M11.46 20.846a12 12 0 0 1 -7.96 -14.846a12 12 0 0 0 8.5 -3a12 12 0 0 0 8.5 3a12 12 0 0 1 -.09 7.06"/><path d="M15 19l2 2l4 -4"/></Icon>),
  bank: (c) => (<Icon color={c}><path d="M3 21l18 0"/><path d="M3 10l18 0"/><path d="M5 6l7 -3l7 3"/><path d="M4 10l0 11"/><path d="M20 10l0 11"/><path d="M8 14l0 3"/><path d="M12 14l0 3"/><path d="M16 14l0 3"/></Icon>),
  file: (c) => (<Icon color={c}><path d="M14 3v4a1 1 0 0 0 1 1h4"/><path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"/></Icon>),
  logout: (c) => (<Icon size={17} color={c}><path d="M14 8v-2a2 2 0 0 0 -2 -2h-7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2 -2v-2"/><path d="M9 12h12l-3 -3"/><path d="M18 15l3 -3"/></Icon>),
  dashboard: (c) => (<Icon color={c}><path d="M4 4h6v8h-6zM4 16h6v4h-6zM14 12h6v8h-6zM14 4h6v4h-6z"/></Icon>),
  settings: (c) => (<Icon color={c}><path d="M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"/></Icon>),
  receipt: (c) => (<Icon color={c}><path d="M5 21v-16a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v16l-3 -2l-2 2l-2 -2l-2 2l-2 -2l-3 2M9 7h6M9 11h6M9 15h4"/></Icon>),
  inbox: (c) => (<Icon color={c}><path d="M4 13h3l3 3h4l3 -3h3"/><path d="M4 13v6a1 1 0 0 0 1 1h14a1 1 0 0 0 1 -1v-6l-3 -7a1 1 0 0 0 -1 -1h-8a1 1 0 0 0 -1 1z"/></Icon>),
  search_doc: (c) => (<Icon color={c}><path d="M14 3v4a1 1 0 0 0 1 1h4"/><path d="M12 21h-5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v4"/><path d="M16.5 17.5m-2.5 0a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0 -5 0"/><path d="M18.5 19.5l2.5 2.5"/></Icon>),
  documents: (c) => (<Icon color={c}><path d="M14 3v4a1 1 0 0 0 1 1h4"/><path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"/><path d="M9 13l6 0"/><path d="M9 17l6 0"/></Icon>),
};

const ICON_FOR = {
  '/intermediaires': 'briefcase',
  '/clients':        'users',
  '/sinistres':      'alert',
  '/prestataires':   'truck',
  '/dossiers/pending-validation': 'hourglass',
  '/dossiers/pending-payment':    'banknote',
  '/dossiers/closed':             'check_circle',
  '/polices':        'shield',
  '/gf':             'bank',
  '/demandes-ouverture': 'inbox',
  '/demandes-etude': 'search_doc',
  '/demandes-etude-rcpro': 'search_doc',
};

// ── Item de navigation : surbrillance "texte + soulignement orange",
//    effet de grossissement au survol. Utilisé pour les items et sous-items.
function NavItem({ to, label, iconFn, end, isChild, hasChildren, badge }) {
  const [hover, setHover] = useState(false);
  return (
    <NavLink to={to} end={end}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={({ isActive }) => ({
        display: 'flex', alignItems: 'center', gap: isChild ? 9 : 11,
        padding: isChild ? '8px 10px' : '9px 10px',
        fontSize: isChild ? 12.5 : 13, textDecoration: 'none',
        color: isActive ? WHITE : MUTED,
        background: hover && !isActive ? HOVER_BG : 'transparent',
        borderRadius: 8,
        fontWeight: (isActive || hasChildren) ? 500 : 400,
        transform: hover ? 'scale(1.05)' : 'scale(1)',
        transformOrigin: 'left center',
        transition: 'transform .18s ease, color .18s ease, background .18s ease',
      })}>
      {({ isActive }) => (
        <>
          {iconFn(isActive || hover ? ORANGE : MUTED)}
          <span style={{
            color: isActive ? WHITE : (hover ? WHITE : MUTED),
            borderBottom: isActive ? `2px solid ${ORANGE}` : '2px solid transparent',
            paddingBottom: 2, transition: 'border-color .18s ease',
          }}>
            {label}
          </span>
          {badge > 0 && (
            <span style={{
              marginLeft: 'auto', minWidth: 18, height: 18, padding: '0 5px',
              display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
              background: '#E11D48', color: '#fff', fontSize: 11, fontWeight: 700,
              borderRadius: 9, lineHeight: 1, boxShadow: '0 0 0 2px rgba(225,29,72,.18)',
            }}>
              {badge > 99 ? '99+' : badge}
            </span>
          )}
        </>
      )}
    </NavLink>
  );
}

export default function Sidebar() {
  const { lang, setLang, t } = useLanguage();
  const { user, logout, isCourtier, isArcus, isVoyageur, dossierId, procedureId, isClient, clientId, isIT } = useAuth();

  const ROLE_STYLE = {
    manager:      { label: t('nav.role_manager') },
    souscripteur: { label: t('nav.role_souscripteur') },
    accounts:     { label: t('nav.role_accounts') },
    it:           { label: t('nav.role_it') },
    courtier:     { label: t('nav.role_courtier') },
    client:       { label: t('nav.role_client') },
    voyageur:     { label: t('nav.role_voyageur') },
  };

  const gestionItems = [
    ...(!isCourtier ? [{ to: '/intermediaires', label: t('nav.intermediaires'), icon: 'briefcase' }] : []),
    { to: '/clients', label: t('nav.clients'), icon: 'users' },
  ];
  const role = user?.role;
  const isManager     = role === 'manager';
  const isSouscripteur= role === 'souscripteur';
  const isAccounts    = role === 'accounts';

  // ── Compteurs GF pour les badges (demandes d'ouverture + d'étude) ──
  // Rafraîchis au montage puis toutes les 60 s, comme des notifications.
  const [gfCounts, setGfCounts] = useState({ ouvertures: 0, etudes_gf: 0, etudes_rcpro: 0, declarations_ca: 0 });
  useEffect(() => {
    if (!(isManager || isSouscripteur || isIT)) return;
    let active = true;
    const fetchCounts = () => {
      const token = localStorage.getItem('arcus_token');
      fetch('/api/polices/demandes-counts', {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      })
        .then(r => r.ok ? r.json() : null)
        .then(d => { if (active && d) setGfCounts({ ouvertures: d.ouvertures || 0, etudes_gf: d.etudes_gf || 0, etudes_rcpro: d.etudes_rcpro || 0, declarations_ca: d.declarations_ca || 0 }); })
        .catch(() => {});
    };
    fetchCounts();
    const iv = setInterval(fetchCounts, 60000);
    return () => { active = false; clearInterval(iv); };
  }, [isManager, isSouscripteur, isIT]);

  // ── Sinistres : "Gestion sinistre" est un menu maître avec sous-menus ──
  const gestionSinistreChildren = isArcus ? [
    // En attente validation : Admin (souscripteur) + Manager + IT
    ...((isManager || isSouscripteur || isIT) ? [
      { to: '/dossiers/pending-validation', label: t('nav.pending_validation'), icon: 'hourglass' },
    ] : []),
    // En attente paiement : Accounts + Manager + IT
    ...((isAccounts || isManager || isIT) ? [
      { to: '/dossiers/pending-payment',    label: t('nav.pending_payment'),    icon: 'banknote' },
    ] : []),
    // Soldes en attente (appels de fonds générés) : Admin + Accounts + Manager + IT
    ...((isSouscripteur || isAccounts || isManager || isIT) ? [
      { to: '/dossiers/pending-balances',   label: t('nav.pending_balances'),   icon: 'receipt' },
    ] : []),
    // Dossiers clos : Manager + Accounts + IT
    ...((isManager || isAccounts || isIT) ? [
      { to: '/dossiers/closed',             label: t('nav.closed_dossiers'),    icon: 'check_circle' },
    ] : []),
  ] : [];

  const sinistresItems = isArcus ? [
    { to: '/sinistres', label: t('nav.sinistres'), icon: 'alert', children: gestionSinistreChildren },
    { to: '/prestataires', label: t('nav.prestataires'), icon: 'truck' },
  ] : [];
  const dashboardItem = isArcus ? [{ to: '/dashboard', label: t('nav.dashboard'), icon: 'dashboard' }] : [];
  const clientItem = isClient && clientId
    ? [{ to: `/clients/${clientId}/detail`, label: t('nav.client_mes_polices'), icon: 'users' }]
    : [];
  const voyageurItem = isVoyageur && dossierId && procedureId
    ? [{ to: `/sinistres/${procedureId}/dossiers/${dossierId}`, label: t('sinistres.voyageur_mon_dossier'), icon: 'file' }]
    : [];

  const NAV = isVoyageur ? [
    { section: t('sinistres.voyageur_space'), items: voyageurItem },
  ] : isClient ? [
    { section: t('nav.client_space'), items: clientItem },
  ] : [
    ...( dashboardItem.length ? [{ section: t('nav.section_pilotage'), items: dashboardItem }] : []),
    { section: t('nav.section_gestion'), items: gestionItems },
    ...( sinistresItems.length ? [{ section: t('nav.section_sinistres'), items: sinistresItems }] : []),
    { section: t('nav.section_portfolio'), items: [
      // RC Professionnelle : menu maître. "Demandes d'étude" (Arcus admin) en sous-menu.
      { to: '/polices', label: t('nav.polices'), icon: 'shield',
        children: ((isManager || isSouscripteur || isIT) ? [
          { to: '/demandes-etude-rcpro', label: t('nav.rcpro_studies'), icon: 'search_doc', badge: gfCounts.etudes_rcpro },
        ] : []) },
      // Garantie Financière : menu maître. Les "Demandes d'ouverture" (Arcus admin)
      // sont un sous-menu de la GF.
      { to: '/gf', label: t('nav.gf'), icon: 'bank',
        children: ((isManager || isSouscripteur || isIT) ? [
          { to: '/demandes-ouverture', label: t('nav.gf_requests'), icon: 'inbox', badge: gfCounts.ouvertures },
          { to: '/demandes-etude',     label: t('nav.gf_studies'),  icon: 'search_doc', badge: gfCounts.etudes_gf },
          { to: '/declarations-ca',    label: t('nav.gf_declarations'), icon: 'receipt', badge: gfCounts.declarations_ca },
        ] : []) },
    ]},
    ...( isIT ? [{ section: t('nav.section_administration'), items: [
      { to: '/utilisateurs', label: t('nav.utilisateurs'), icon: 'settings' },
      { to: '/gestion-documentaire', label: t('nav.gestion_doc'), icon: 'documents' },
    ]}] : []),
  ];

  return (
    <nav style={{
      width: 240, flexShrink: 0, background: SIDEBAR,
      display: 'flex', flexDirection: 'column', minHeight: '100vh',
    }}>
      {/* ── Logo ── */}
      <div style={{ padding: '20px 18px 16px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <div style={{ width: 34, height: 34, borderRadius: 8, background: ORANGE,
            display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
            <Icon size={20} color={SIDEBAR}>
              <path d="M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1 -8.5 15a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3"/>
            </Icon>
          </div>
          <div>
            <div style={{ fontSize: 15, fontWeight: 600, color: WHITE, letterSpacing: '.02em' }}>
              ARCUS<span style={{ color: ORANGE }}>CONNECT</span>
            </div>
            <div style={{ fontSize: 10, color: FAINT, letterSpacing: '.12em', marginTop: 1 }}>
              {t('nav.crm_subtitle')}
            </div>
          </div>
        </div>
      </div>

      {/* ── Sélecteur de langue (dropdown) ── */}
      <LanguageDropdown lang={lang} setLang={setLang} t={t} />

      {/* ── Navigation ── */}
      <div style={{ flex: 1, padding: '4px 10px' }}>
        {NAV.map(group => (
          <div key={group.section}>
            <div style={{ fontSize: 10, fontWeight: 500, color: FAINT,
              padding: '14px 8px 6px', textTransform: 'uppercase', letterSpacing: '.1em' }}>
              {group.section}
            </div>
            {group.items.map(item => {
              const IconFn = Icons[item.icon] || Icons.file;
              const hasChildren = Array.isArray(item.children) && item.children.length > 0;
              return (
                <div key={item.to}>
                  <NavItem to={item.to} label={item.label} iconFn={IconFn}
                    end={hasChildren ? false : undefined} hasChildren={hasChildren} />
                  {/* Sous-menus du menu maître */}
                  {hasChildren && (
                    <div style={{ marginLeft: 14, paddingLeft: 8, borderLeft: `1px solid ${DIVIDER}` }}>
                      {item.children.map(child => {
                        const ChildIcon = Icons[child.icon] || Icons.file;
                        return (
                          <NavItem key={child.to} to={child.to} label={child.label}
                            iconFn={ChildIcon} isChild badge={child.badge} />
                        );
                      })}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        ))}
      </div>

      {/* ── Profil + Déconnexion ── */}
      <div style={{ padding: '12px 12px 16px', borderTop: `0.5px solid ${DIVIDER}` }}>
        {user && (
          <NavLink to="/mon-compte"
            style={({ isActive }) => ({
              display:'flex', alignItems:'center', gap:10, padding:'8px 6px 12px',
              textDecoration:'none', borderRadius:8, marginBottom:4,
              background: isActive ? HOVER_BG : 'transparent',
              transition:'background .12s',
            })}>
            <div style={{ width: 34, height: 34, borderRadius: '50%', background: ORANGE,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 13, fontWeight: 500, color: SIDEBAR, flexShrink: 0 }}>
              {(user.prenom?.[0] || user.nom?.[0] || user.email?.[0] || '?').toUpperCase()}
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: 13, fontWeight: 500, color: WHITE,
                overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {[user.prenom, user.nom].filter(Boolean).join(' ') || user.email}
              </div>
              {ROLE_STYLE[user.role] && (
                <span style={{ fontSize: 10, padding: '1px 8px', borderRadius: 99, fontWeight: 500,
                  background: DIVIDER, color: ORANGE, display: 'inline-block', marginTop: 3 }}>
                  {ROLE_STYLE[user.role].label}
                </span>
              )}
            </div>
          </NavLink>
        )}
        <button onClick={logout}
          style={{ width: '100%', padding: '9px 0', borderRadius: 8, border: 'none',
            background: HOVER_BG, color: MUTED, cursor: 'pointer', fontSize: 13, fontWeight: 500,
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
            transition: 'all .12s' }}
          onMouseEnter={e => { e.currentTarget.style.background = '#3A4654'; e.currentTarget.style.color = WHITE; }}
          onMouseLeave={e => { e.currentTarget.style.background = HOVER_BG; e.currentTarget.style.color = MUTED; }}>
          {Icons.logout(MUTED)} {t('auth.logout')}
        </button>
        <div style={{ fontSize: 10, color: '#5E6B7A', marginTop: 10, textAlign: 'center' }}>arcus-solutions.fr</div>
      </div>
    </nav>
  );
}

// ── Sélecteur de langue (dropdown) ───────────────────────────────
const LANGUAGES = [
  { code: 'fr', label: 'Français', short: 'FR' },
  { code: 'en', label: 'English',  short: 'EN' },
  { code: 'de', label: 'Deutsch',  short: 'DE' },
  { code: 'sv', label: 'Svenska',  short: 'SV' },
];

function LanguageDropdown({ lang, setLang }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  // Fermeture au clic extérieur
  useEffect(() => {
    if (!open) return;
    const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, [open]);

  const current = LANGUAGES.find(l => l.code === lang) || LANGUAGES[0];

  return (
    <div style={{ padding: '0 14px 14px', position: 'relative' }} ref={ref}>
      {/* Bouton déclencheur */}
      <button
        onClick={() => setOpen(o => !o)}
        style={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 8,
          padding: '8px 12px',
          background: '#323B47',
          border: '1px solid #3A4654',
          borderRadius: 8,
          color: '#E8EDF2',
          fontSize: 13,
          fontWeight: 500,
          cursor: 'pointer',
          transition: 'background .12s, border-color .12s',
        }}
        onMouseEnter={e => { e.currentTarget.style.background = '#3A4654'; e.currentTarget.style.borderColor = '#4A5666'; }}
        onMouseLeave={e => { e.currentTarget.style.background = '#323B47'; e.currentTarget.style.borderColor = '#3A4654'; }}>
        <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          {/* Icône globe (Tabler) */}
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none"
            stroke="#F18A00" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="9"/>
            <path d="M3.6 9h16.8M3.6 15h16.8M11.5 3a17 17 0 0 0 0 18M12.5 3a17 17 0 0 1 0 18"/>
          </svg>
          <span>{current.label}</span>
          <span style={{ fontSize: 10, color: '#8A8A8A', fontWeight: 700, letterSpacing: '.06em' }}>{current.short}</span>
        </span>
        {/* Chevron */}
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
          stroke="#8A8A8A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
          style={{ transform: open ? 'rotate(180deg)' : 'none', transition: 'transform .15s' }}>
          <path d="M6 9l6 6l6 -6"/>
        </svg>
      </button>

      {/* Liste déroulante */}
      {open && (
        <div style={{
          position: 'absolute',
          top: 'calc(100% - 6px)',
          left: 14,
          right: 14,
          background: '#252D38',
          border: '1px solid #3A4654',
          borderRadius: 8,
          padding: 4,
          boxShadow: '0 8px 24px rgba(0,0,0,.4)',
          zIndex: 50,
        }}>
          {LANGUAGES.map(l => {
            const active = l.code === lang;
            return (
              <button key={l.code}
                onClick={() => { setLang(l.code); setOpen(false); }}
                style={{
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  gap: 8,
                  padding: '7px 10px',
                  background: active ? 'rgba(241,138,0,.14)' : 'transparent',
                  border: 'none',
                  borderRadius: 6,
                  color: active ? '#F18A00' : '#C3D0DD',
                  fontSize: 13,
                  fontWeight: active ? 600 : 400,
                  cursor: 'pointer',
                  textAlign: 'left',
                  transition: 'background .1s',
                }}
                onMouseEnter={e => { if (!active) e.currentTarget.style.background = '#2F3845'; }}
                onMouseLeave={e => { if (!active) e.currentTarget.style.background = 'transparent'; }}>
                <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <span>{l.label}</span>
                  <span style={{ fontSize: 10, color: '#666', fontWeight: 700, letterSpacing: '.06em' }}>{l.short}</span>
                </span>
                {active && (
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
                    stroke="#F18A00" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M5 12l5 5l10 -10"/>
                  </svg>
                )}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
